export const isValidExtent = (extent: null | undefined | number[]) => {
  if (!extent || !Array.isArray(extent) || extent.length !== 4) {
    return false;
  }

  const hasValidCoords = extent.every(
    (coord) =>
      coord !== Infinity && coord !== -Infinity && typeof coord === 'number',
  );

  return hasValidCoords && extent[0] < extent[2] && extent[1] < extent[3];
};
